<!-- @format -->
<template>
    <div class="autotask-export-contact-widget">
        <autotask-export-widget-contacts-step
            :selectedContacts="selectedContacts"
            :url="webUrl"
            @closeWidget="closeWidget($event)"
        />
    </div>
</template>

<script>
const AutotaskExportWidgetContactsStep = () =>
    import(
        '@/components/sliding-widgets/autotask-export-widget/autotask-export-widget-contacts-step'
    );

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'AutotaskExportContactWidget',

    components: {
        'autotask-export-widget-contacts-step': AutotaskExportWidgetContactsStep,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            contact: {
                id: this.widget.id,
                name: null,
                profileImageUrl: null,
                autoTaskContactId: null,
            },

            webUrl: '',
        };
    },

    computed: {
        selectedContacts() {
            return [this.contact];
        },

        clientId() {
            return this.$store.state.context.client.id;
        },

    },

    created() {
        this.getData()
        this.getIntegrationInformation();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        getIntegrationInformation() {
            this.$api
                .get(`/ms/autotask-api/v1/credentials/${ this.clientId }`)
                .then(({ data }) => {
                    this.webUrl = data.data.webUrl;
                });
        },

        getData() {
            var filter = `$filter=Id eq ${this.contact.id}`;
            var select = `$select=FirstName,LastName,ProfileImageUrl,AutoTaskContactId`;
            var query = `/service/Contacts?${filter}&${select}`;

            this.$api
                .get(query)
                .then((response) => {
                    this.contact.name = this.$helpers.getName(
                        response.data.value[0].FirstName,
                        response.data.value[0].LastName
                    );

                    this.contact.profileImageUrl =
                        response.data.value[0].ProfileImageUrl ||
                        require('@/assets/images/avatar.png');

                    this.contact.autotaskContactId = response.data.value[0].AutoTaskContactId;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to fetch contact to export', {
                        error,
                    });
                    this.closeWidget();
                });
        },
    },
};
</script>

<style>
.autotask-export-contact-widget .action-container .back-btn {
    width: 128px;
    background: transparent;
    color: #18aeff;
    margin-right: 10px;
}

.autotask-export-contact-widget .action-container .back-btn:hover {
    background: #e1e0e5;
}

.autotask-export-contact-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.autotask-export-contact-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.autotask-export-contact-widget .action-container {
    display: flex;
}

.autotask-export-contact-widget .loading {
    text-align: center;
}
</style>
